import {
  ArchiveBoxIcon,
  DocumentIcon,
  InboxIcon,
  PaperAirplaneIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";

export const DEFAULT_ADMIN_MAILBOX_FOLDERS = [
  { name: "Postvak in", path: "INBOX", icon: InboxIcon },
  { name: "Concepten", path: "Drafts", icon: DocumentIcon },
  { name: "Verzonden", path: "Sent", icon: PaperAirplaneIcon },
  { name: "Prullenbak", path: "Trash", icon: TrashIcon },
  { name: "Spam", path: "Spam", icon: ArchiveBoxIcon },
];

const FOLDER_RULES = [
  { name: "Postvak in", specialUse: "\\Inbox", fallback: "INBOX", icon: InboxIcon },
  { name: "Concepten", specialUse: "\\Drafts", fallback: "Drafts", icon: DocumentIcon },
  { name: "Verzonden", specialUse: "\\Sent", fallback: "Sent", icon: PaperAirplaneIcon },
  { name: "Prullenbak", specialUse: "\\Trash", fallback: "Trash", icon: TrashIcon },
  { name: "Spam", specialUse: "\\Junk", fallback: "Spam", icon: ArchiveBoxIcon },
];

const normalize = (value) => String(value || "").trim().toLowerCase();

const matchesFallback = (folder, fallback) => {
  const path = normalize(folder?.path);
  const name = normalize(folder?.name);
  const target = normalize(fallback);
  return path === target || name === target;
};

const findFolder = (folders, rule) =>
  folders.find((folder) => normalize(folder?.specialUse) === normalize(rule.specialUse)) ||
  folders.find((folder) => matchesFallback(folder, rule.fallback));

const labelForFolder = (folder) => {
  const rule = FOLDER_RULES.find(
    (item) =>
      normalize(folder?.specialUse) === normalize(item.specialUse) ||
      matchesFallback(folder, item.fallback)
  );
  return rule?.name || folder?.name || folder?.path;
};

function dedupeFolders(folders) {
  const seen = new Set();
  return folders.filter((folder) => {
    const key = normalize(folder?.path);
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}

export function buildAdminMailboxFolders(folders = []) {
  if (!Array.isArray(folders) || folders.length === 0) {
    return DEFAULT_ADMIN_MAILBOX_FOLDERS;
  }

  return FOLDER_RULES.map((rule) => {
    const folder = findFolder(folders, rule);
    return {
      name: rule.name,
      path: folder?.path || rule.fallback,
      icon: rule.icon,
    };
  });
}

export function buildAdminMailboxMoveFolders(folders = []) {
  if (!Array.isArray(folders) || folders.length === 0) {
    return DEFAULT_ADMIN_MAILBOX_FOLDERS;
  }

  return dedupeFolders(folders)
    .filter((folder) => folder?.path)
    .map((folder) => ({
      name: labelForFolder(folder),
      path: folder.path,
      icon:
        FOLDER_RULES.find(
          (rule) =>
            normalize(folder?.specialUse) === normalize(rule.specialUse) ||
            matchesFallback(folder, rule.fallback)
        )?.icon || ArchiveBoxIcon,
    }));
}
